import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Userdata } from '../../../../interfaces/userdata';

@Component({
    selector: 'app-header',
    standalone: false,
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent {
    @Input({ required: true })
    public userData: Userdata | undefined = undefined;

    @Output()
    public onNewStreamClick = new EventEmitter<void>();

    protected newStream(): void {
        this.onNewStreamClick.emit();
    }
}

